// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='-3 -3 16 12'
    ...attributes
  ><path
      fill='var(--icon-fill, #000)'
      stroke='var(--icon-color,#000)'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
      d='m5.414 6.414-4-4 4-4z'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'TriangleLeft';
export default IconComponent;
